var cilArrowThickRight = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M254.3,496H216.025l-.008-143.937H16v-192H216.007L216,16.048l38.688.035L494.636,256.318ZM48,320.063H248.015l.007,137.006,201.342-200.8L248,54.672l.008,137.391H48Z' class='ci-primary'/>"];

export { cilArrowThickRight };
